const animes = [
  {
    title: "幻夜之都",
    tag: "冒险 · 奇幻",
    desc: "在被霓虹笼罩的夜之城，少年与影子订下契约，踏上探寻失落之塔的旅程。",
    src: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20boy%20standing%20in%20a%20neon%20night%20city%20with%20warm%20coral%20and%20teal%20lights%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20clean%20dark%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=anime-01-kf&orientation=portrait",
  },
  {
    title: "星海旅人",
    tag: "科幻 · 热血",
    desc: "一艘旧船穿行星系之间，船员们用音乐与勇气，守护流浪星民最后的家园。",
    src: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20an%20astronaut%20traveler%20gazing%20at%20colorful%20starry%20space%20nebula%20in%20coral%20orange%20and%20teal%20tones%2C%20epic%20and%20dreamy%2C%20clean%20dark%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=anime-02-kf&orientation=portrait",
  },
  {
    title: "夏日蝉鸣",
    tag: "青春 · 治愈",
    desc: "那个夏天，蝉鸣与少年心事交织。关于成长、告别，以及一封未寄出的信。",
    src: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20girl%20under%20summer%20sunshine%20with%20cherry%20blossoms%20and%20warm%20golden%20light%2C%20soft%20healing%20atmosphere%2C%20warm%20coral%20and%20amber%20palette%2C%20clean%20dark%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=anime-03-kf&orientation=portrait",
  },
  {
    title: "剑与回响",
    tag: "战斗 · 热血",
    desc: "断剑重铸之日，骑士归来之时。每一击都划破宿命，每一战都掷地有声。",
    src: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20sword%20warrior%20in%20dynamic%20combat%20pose%20with%20glowing%20blade%20and%20embers%2C%20warm%20coral%20and%20teal%20contrast%2C%20dramatic%20lighting%2C%20clean%20dark%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=anime-04-kf&orientation=portrait",
  },
  {
    title: "迷雾图书馆",
    tag: "悬疑 · 奇幻",
    desc: "传说午夜时分，图书馆会开启通往书页世界的大门，而管理员却下落不明。",
    src: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20mysterious%20library%20with%20floating%20glowing%20books%20and%20soft%20fog%2C%20teal%20and%20amber%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20dark%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=anime-05-kf&orientation=portrait",
  },
  {
    title: "云端食堂",
    tag: "美食 · 日常",
    desc: "开在云朵之上的小食堂，用一道道暖心料理，治愈每一位到访者的烦恼。",
    src: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20cozy%20diner%20with%20steaming%20delicious%20food%20and%20soft%20warm%20light%20on%20a%20cloud%2C%20warm%20coral%20and%20amber%20palette%2C%20heartwarming%20atmosphere%2C%20clean%20dark%20background%2C%20high%20detail%20digital%20art&width=400&height=560&seq=anime-06-kf&orientation=portrait",
  },
];

export default function AnimeList() {
  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-block rounded-full bg-primary-100 px-4 py-1 text-sm font-medium text-primary-900">
              热门推荐
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              本周大家都在看
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              每部番剧都已接入多线路播放源，遇到卡顿随时切换备用线路，畅看无压力。
            </p>
          </div>
          <span className="flex items-center gap-2 whitespace-nowrap text-sm text-secondary-700">
            <i className="ri-fire-line text-accent-500"></i>
            实时更新中
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {animes.map((a) => (
            <article
              key={a.title}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <a href="#hot" className="relative block overflow-hidden">
                <div className="aspect-[4/5] w-full">
                  <img
                    src={a.src}
                    alt={`${a.title}动漫海报`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/70 px-2 py-1 text-xs text-white backdrop-blur">
                  {a.tag}
                </span>
              </a>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 md:text-lg">
                  <a href="#hot" className="hover:text-primary-600">{a.title}</a>
                </h3>
                <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-700">
                  {a.desc}
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">
                    多线路
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                    高清
                  </span>
                  <span className="ml-auto flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className="ri-play-fill"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}